import React, {Component} from "react";
import App from "../../App";
import ProductService from "../../services/product-service";
import toastr from "toastr";
import ToastOptions from "../../common/toast/toastr-config";
import Loading from "../../common/Loading/Loading";
import HistoryBackLink from "../../common/BackLink/HistoryBackLink";
import ProductHeader from "./components/ProductHeader";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ApiServices from "./components/ApiServices";
import ListHandler from "../../common/ListHandler/ListHandler";
import ActivationButton from "../../common/ActivationButton/ActivationButton";
import "./ProductDetails.css";
import {AppUsers} from "../../user-search/AppUsers";
import Permissions from "../../authentication/Permissions";
import AuthorizationService from "../../services/authorization-service";

class ProductDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            product: {type: ""},
            roles: [],
            attributes: [],
            environments: [],
            tenants: [],
            services: [],
            isDeactivateProductModalVisible: false,
            isDialogLoading: false
        };
    }

    componentWillMount() {
        this.fetchProduct();
    }

    fetchProduct = async () => {
        try {
            this.setState({loading: true});
            const productId = this.props.match.params.id;
            const product = await ProductService.getProductById(productId);
            this.initializeStates(product.data);
        } catch (error) {
            toastr.options = ToastOptions;
            toastr.error(error.message);
        }
    };

    initializeStates = data => {
        this.setState({
            loading: false,
            isDialogLoading: false,
            product: data,
            services: data.services ? data.services : [],
            roles: data.roles ? data.roles : [],
            attributes: data.attributes ? data.attributes : [],
            tenants: data.tenants ? data.tenants : [],
            environments: data.environments ? data.environments : []
        });
    };

    handleErrors = error => {
        let errorData = error.response.data;
        let statusCode = errorData.statusCode;
        let name = errorData.name;

        if (name === "Validation Error") {
            let newState = this.state.invalidFields;
            if (statusCode === 400) {
                let body = errorData.body;
                body.forEach(fieldError => {
                    let field = fieldError.field;
                    let message = fieldError.message;

                    if (field === "name") {
                        newState.name.invalid = true;
                        newState.name.message = message;
                    }
                });
            }
            this.setState({invalidFields: newState});
            toastr.options = ToastOptions;
            toastr.error(`${errorData.message}.`);
        } else {
            toastr.options = ToastOptions;
            toastr.error(error.message);
        }
    };

    updateServiceCode = (value) => {
        this.updateField("serviceCode", value);
    }

    updateField = (field, value) => {
        let updatedProduct = {...this.state.product}
        updatedProduct[field] = value;
        this.updateProduct(updatedProduct);
    }

    updateDescription = (value) => {
        this.updateField("description", value);
    }

    updateProduct = async (product) => {
        try {
            this.setState({isDialogLoading: true});
            const response = await ProductService.updateProduct(product.uuid, product);
            this.initializeStates(response.data);
            toastr.options = ToastOptions;
            toastr.success("The product has been updated.");
        } catch (err) {
            this.setState({isDialogLoading: false});
            this.handleErrors(err);
        }
    };

    updateIsActiveStatus = async () => {
        this.updateField("isActive", !this.state.product.isActive);
    };

    setRoles = roles => {
        this.updateField("roles", roles);
    };

    setServices = services => {
        this.updateField("services", services);
    }

    setEnvironments = environments => {
        this.updateField("environments", environments);
    };

    setAttributes = attributes => {
        //this.updateField("attributes", attributes);
        this.updateField("attributes", attributes);
    };

    setTenants = tenants => {
        this.updateField("tenants", tenants);
    };

    render() {
        return (
            <App {...this.props}>
                {this.state.loading && <Loading/>}
                <HistoryBackLink directionName="Products"/>

                <div className="product-details">
                    <div className="product-title">
                        <span className="name">{this.state.product.name}</span>
                        <div className="actions">
                            {AuthorizationService.hasPermission(Permissions.product.changeStatus) &&
                            <ActivationButton
                                item={this.state.product}
                                isActive={this.state.product.isActive}
                                header="product"
                                description={`product with name: ${this.state.product.name} ?`}
                                toggleFunction={this.updateIsActiveStatus}
                            />

                            }
                        </div>
                    </div>

                    <ProductHeader
                        product={this.state.product}
                        updateServiceCode={this.updateServiceCode}
                        updateDescription={this.updateDescription}
                    />

                    <Tabs defaultActiveKey="default" id="uncontrolled-tab-example">
                        {this.state.product.type === "API" &&
                        <Tab eventKey="default" title="API Services">
                            <ApiServices
                                product={this.state.product}
                                handleAddServiceDialogToggle={this.handleAddServiceDialogToggle}
                                editHandler={this.setServices}
                            />
                        </Tab>
                        }
                        {this.state.product.type === "USER" &&
                        <Tab eventKey="default" title="Roles">
                            <ListHandler
                                type="ROLE"
                                list={this.state.roles}
                                editHandler={this.setRoles}
                                includeType="false"
                                permission={Permissions.product.edit}
                            />
                        </Tab>
                        }
                        {this.state.product.type === "USER" &&
                        <Tab eventKey="attributes" title="Attributes">
                            <ListHandler
                                type="ATTRIBUTE"
                                list={this.state.attributes}
                                editHandler={this.setAttributes}
                                includeType="true"
                                permission={Permissions.product.edit}
                            />
                        </Tab>
                        }
                        {this.state.product.type === "USER" &&
                        <Tab eventKey="environments" title="Environments">
                            <ListHandler
                                type="ENVIRONMENT"
                                list={this.state.environments}
                                editHandler={this.setEnvironments}
                                includeType="false"
                                permission={Permissions.product.edit}
                            />
                        </Tab>
                        }
                        {this.state.product.type === "USER" && this.state.product.appStructure === "tenant" &&
                        <Tab eventKey="tenants" title="Tenants">
                            <ListHandler
                                type="TENANT"
                                list={this.state.tenants}
                                editHandler={this.setTenants}
                                includeType="false"
                                permission={Permissions.product.edit}
                            />
                        </Tab>
                        }
                        {this.state.product.type === "USER" &&
                        <Tab eventKey="users" title="Users">
                            <AppUsers
                                appName={this.state.product.appName}
                            />
                        </Tab>
                        }

                    </Tabs>
                </div>

            </App>
        );
    }
}

export default ProductDetails;



// WEBPACK FOOTER //
// ./src/products/product-details/ProductDetails.js